import "./Home.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import PrecisionDemolitionRapidHauling from "./sections/PrecisionDemolitionRapidHauling";
import CertifiedByExcellence from "./sections/CertifiedByExcellence";
import TheCostOfInaction from "./sections/TheCostOfInaction";
import MeetTheSilentOperator from "./sections/MeetTheSilentOperator";
import TheAbyssPreOrder from "./sections/TheAbyssPreOrder";
import LocalSupport from "./sections/LocalSupport";
import Footer from "@/reusable_sections/Footer";
import Services from "./sections/Services";
export default function HomePage() {
  return <div>
      <NavigationHeader />
      <PrecisionDemolitionRapidHauling />
      <Services />
      <CertifiedByExcellence />
      <TheCostOfInaction />
      <MeetTheSilentOperator />
      <TheAbyssPreOrder />
      <LocalSupport />
      <Footer />
    </div>;
}